import { AUTH, getBaseApi, getData, postData } from './index';

export const login = (email, password) => postData(`${getBaseApi(AUTH)}login`, { email, password });
export const logout = () => getData(`${getBaseApi(AUTH)}logout`);
